import { render, staticRenderFns } from "./mastery-competency-completion-setting.vue?vue&type=template&id=92819ffa&"
import script from "./mastery-competency-completion-setting.ts?vue&type=script&lang=ts&"
export * from "./mastery-competency-completion-setting.ts?vue&type=script&lang=ts&"
import style0 from "./mastery-competency-completion-setting.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports